import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import moment from 'moment';
import { history } from '../../state/store';
import MultiSelect from '@khanacademy/react-multi-select';

import EventApi from '../../api/event';
import OrganizationApi from '../../api/organization';

import Button from '../form/Button';
import Checkbox from '../form/Checkbox';
import Message from '../form/Message';
import Subnav from '../subnav';

class ScheduleEditPage extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            practiceOptions: [],
            checkinOptions: [
                { value: 1, label: '1' },
                { value: 2, label: '2' },
                { value: 3, label: '3' },
            ],
            titleOptions: [
                {
                    value: 'Q-Pass Load Deadline 1',
                    label: 'Q-Pass Load Deadline 1',
                },
                {
                    value: 'Q-Pass Load Deadline 2',
                    label: 'Q-Pass Load Deadline 2',
                },
                {
                    value: 'Q-Pass Load Deadline 3',
                    label: 'Q-Pass Load Deadline 3',
                },
            ],
            event: {
                practice_ids: [],
            },
            selected_practices: [],
        };
        this.createEvent = this.createEvent.bind(this);
        this.goBack = this.goBack.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.onSelectCheckin = this.onSelectCheckin.bind(this);
        this.onSelectTitle = this.onSelectTitle.bind(this);
        this.onSaveEvent = this.onSaveEvent.bind(this);
        this.updateEvent = this.updateEvent.bind(this);
        this.toggleCompleteChange = this.toggleCompleteChange.bind(this);
    }

    componentDidMount() {
        const { eventId, organizationId } = this.props.match.params;
        if (eventId !== undefined) {
            EventApi.getEvent(eventId).then(event => {
                console.log('Event: ', event);
                const practice_options = event.organization.practices.map(
                    practice => {
                        return { value: practice.id, label: practice.name };
                    }
                );
                const selected_practices = event.practices.map(practice => {
                    return practice.id;
                });
                this.setState({
                    eventId: eventId,
                    event: { ...event, date: moment(event.date) },
                    practiceOptions: practice_options,
                    selected_practices: selected_practices,
                });
            });
        } else {
            OrganizationApi.get(organizationId).then(organization => {
                const practice_options = organization.practices.map(
                    practice => {
                        return { value: practice.id, label: practice.name };
                    }
                );
                this.setState({
                    eventId: eventId,
                    event: { organizaiton_id: organizationId },
                    practiceOptions: practice_options,
                    selected_practices: [],
                });
            });
        }
    }

    updateEvent(change, eventId) {
        // console.log("Change:", JSON.stringify({date: change}));
        const organizationId = this.state.event.organization.id;
        EventApi.update(eventId, change)
            .then(result => {
                this.setState({
                    event: { ...this.state.event, result },
                });
                history.push(`/organization/${organizationId}/schedule`);
                console.log('Success!:', result);
            })
            .catch(error => {
                console.error('Error occurred:', error);
            });
    }

    createEvent(event) {
        EventApi.create(event)
            .then(result => {
                this.setState({
                    event: { ...this.state.event, result },
                });
                history.push(
                    `/organization/${result.organization_id}/schedule/${result.id}/edit`
                );
            })
            .catch(error => {
                console.error('Error occurred:', error);
            });
    }

    goBack() {
        this.props.history.goBack();
    }

    onDateChange(newDate) {
        console.log('onDateChange:', JSON.stringify(newDate));
        this.setState({
            event: { ...this.state.event, date: newDate },
        });
    }

    onSaveEvent() {
        console.log('save state: ', this.state);
        let { event, selected_practices } = this.state;
        let payload = {
            checkin: event.checkin,
            complete: event.complete === true ? true : false,
            date: event.date,
            max_practices: event.max_practices,
            name: event.name,
            practice_ids: selected_practices,
        };
        if (event.id) {
            this.updateEvent(payload, event.id);
        } else {
            payload.organization_id = event.organizaiton_id;
            payload.event_type = 'q_pass_load_deadline';
            this.createEvent(payload);
        }
    }

    onSelectCheckin(selection) {
        console.log(selection);
        this.setState({
            event: { ...this.state.event, checkin: selection.value },
        });
    }

    onSelectPractice(selections) {
        this.setState({
            event: { ...this.state.event, practice_ids: selections },
            selected_practices: selections,
        });
    }

    onSelectTitle(selection) {
        this.setState({
            event: { ...this.state.event, name: selection.value },
        });
    }

    toggleCompleteChange(checked) {
        console.log(checked);
        this.setState({
            event: { ...this.state.event, complete: checked },
        });
    }

    onFormSubmit(event) {
        event.preventDefault();
        // save Event
    }

    render() {
        return (
            <div className="page">
                <div className="page__subnav">
                    <Subnav
                        organizationId={this.props.match.params.organizationId}
                    />
                </div>
                <div className="sidebarpage">
                    <div className="sidebarpage__content">
                        <Message info={this.state.message} />
                        <form onSubmit={this.onFormSubmit}>
                            <h2>
                                {this.state.eventId ? 'Edit' : 'Create'}{' '}
                                Deadline
                            </h2>
                            <div className="form__field">
                                <label htmlFor="checkin">Check-In: </label>
                                <Select
                                    name="checkin"
                                    options={this.state.checkinOptions}
                                    value={this.state.event.checkin}
                                    onChange={this.onSelectCheckin}
                                    //onChange={e => this.changePractice(mem, e)}
                                    clearable={false}
                                    searchable={false}
                                />
                            </div>
                            <div className="form__field">
                                <label htmlFor="title">Title: </label>
                                <Select
                                    name="checkin"
                                    options={this.state.titleOptions}
                                    value={this.state.event.name}
                                    onChange={this.onSelectTitle}
                                    //onChange={e => this.changePractice(mem, e)}
                                    clearable={false}
                                    searchable={false}
                                />
                            </div>
                            <div className="form__field">
                                <label htmlFor="date">Date: </label>
                                <DatePicker
                                    selected={this.state.event.date}
                                    onChange={this.onDateChange}
                                />
                            </div>
                            <div className="form__field">
                                <label htmlFor="complete">Complete: </label>
                                <Checkbox
                                    defaultChecked={this.state.event.complete}
                                    onChange={this.toggleCompleteChange}
                                />
                            </div>
                            <div className="form__field">
                                <label htmlFor="practices">
                                    Associated Practices:
                                </label>
                                <MultiSelect
                                    options={this.state.practiceOptions}
                                    onSelectedChanged={this.onSelectPractice.bind(
                                        this
                                    )}
                                    selected={this.state.selected_practices}
                                    isLoading={this.state.isPracticeListLoading}
                                />
                            </div>
                            <div className="form__buttons">
                                <Button
                                    type="submit"
                                    defaultText="Save"
                                    busyText="Saving Event"
                                    onClick={this.onSaveEvent}
                                />
                                <Link to="" onClick={this.goBack}>
                                    Cancel
                                </Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

export default ScheduleEditPage;
